"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const qs_1 = __importDefault(require("qs"));
const prefix = '/api/ac/v2/kyb/service/published';
const API = {
    getListKYBService: `${prefix}/list`,
    getKYBServiceDetail: `${prefix}/detail`,
    createKYBService: `${prefix}/create`,
    updateKYBService: `${prefix}/update`,
    updateKYBLiveStatus: `${prefix}/updateLiveStatus`,
    allowBlockpassAccess: `${prefix}/bpAccess/update`,
};
class KYBServiceManagementAPI {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    /**
     * Function to get list service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListKYBService(filter = {}, sort, page = 0, limit = 10) {
        const query = {
            filter,
            sort,
            page,
            limit,
        };
        const url = `${API.getListKYBService}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.get(url, {});
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                paging: {
                    page,
                    limit,
                    total: 0,
                },
                entities: {},
            };
        }
        return {
            result: resBody.result,
            paging: resBody.paging,
            entities: resBody.entities,
        };
    }
    /**
     * Function to get KYB service detail
     * @param serviceId - Service Id
     * @returns Return detail of service
     */
    async getKYBServiceDetail(serviceId) {
        const res = await this._httpClient.get(API.getKYBServiceDetail, {
            params: { serviceId },
        });
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return {
                result: null,
                entities: {},
            };
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * Function to create new KYB service
     * @param {string} name service name
     * @param {string} clientId service client Id
     * @param {string} logo service logo link
     * @param {string} thumbnail service thumbnail link
     * @param {string} supportEmail service template
     * @param {boolean} isFirstService it is first service of merchant or not
     * @returns
     */
    async createKYBService(name, clientId, logo, thumbnail, supportEmail, isFirstService) {
        const res = await this._httpClient.post(API.createKYBService, {
            name,
            clientId,
            logo,
            thumbnail,
            supportEmail,
            isFirstService,
        });
        const data = {
            result: null,
            entities: {},
        };
        const resBody = lodash_1.default.get(res, 'data.data', null);
        if (!resBody) {
            return data;
        }
        return {
            result: resBody.result,
            entities: resBody.entities,
        };
    }
    /**
     * API to update KYB service
     * @param {string} serviceId
     * @param {UpdateServiceDisplayPayload} updateParam
     * @returns
     */
    async updateKYBService(serviceId, updateParam) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateKYBService, {
            serviceId,
            ...updateParam,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * API to update KYB service live status
     * @param {string} serviceId
     * @param {boolean} isLive
     * @returns
     */
    async updateKYBLiveStatus(serviceId, isLive) {
        const data = {
            result: null,
            entities: {},
        };
        const res = await this._httpClient.put(API.updateKYBLiveStatus, {
            serviceId,
            isLive,
        });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
    /**
     * API to update Blockpass's access in KYB service
     * @param {string} serviceId
     * @param {boolean} allowBlockpassAccess
     * @returns
     */
    async allowBlockpassAccess(serviceId, allowBlockpassAccess) {
        const data = {
            result: null,
            entities: {},
        };
        const query = {
            serviceId,
        };
        const url = `${API.allowBlockpassAccess}?${qs_1.default.stringify(query)}`;
        const res = await this._httpClient.put(url, { allowBlockpassAccess });
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = KYBServiceManagementAPI;
